<template lang="html">
  <nav class="paginate">
    <ul class="pagination">
      <li :class="`page-item change-page ${current <= 1 ? 'disabled' : ''}`">
        <router-link
          :to="{ path: publicationsPath, query: createQuery(current - 1) }"
          class="page-link"
          aria-label="Previous">
          <font-awesome-icon :icon="[ 'fas', 'angle-left' ]" aria-hidden="true"/>
        </router-link>
      </li>
      <template v-for="page in pageList">
        <li
          :key="page"
          :class="`page-item ${page === current ? 'active' : ''}`">
          <router-link
            :to="{ path: publicationsPath, query: createQuery(page) }"
            class="page-link"
            >
            {{ page }}
          </router-link>
        </li>
      </template>
      <li :class="`page-item change-page ${current >= total ? 'disabled' : ''}`">
        <router-link
          :to="{ path: publicationsPath, query: createQuery(current + 1) }"
          class="page-link"
          aria-label="Next">
          <font-awesome-icon :icon="[ 'fas', 'angle-right' ]" aria-hidden="true"/>
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    current: Number,
    total: Number,
    section: String
  },

  data: () => ({
    windowWidth: 800
  }),

  computed: {
    padding () {
      return this.windowWidth < 360 ? 0 : this.windowWidth < 576 ? 1 : 3
    },

    pageList () {
      const initial = this.current - this.padding > 1
        ? this.current - this.padding : 1

      const final = this.current + this.padding <= this.total
        ? this.current + this.padding : this.total

      let pageList = []

      for (let pos = initial; pos <= final; pos++) pageList.push(pos)

      return pageList
    },

    publicationsPath () {
           if (this.section === 'category') return '/categoria/' + this.$route.params.category
      else if (this.section === 'followedPublications') return '/cuenta/seguidos/publicaciones'
      else if (this.section === 'followedUsers') return '/cuenta/seguidos'
      else if (this.section === 'userPublications') return '/cuenta/publicaciones'
      else if (this.section === 'favorites') return '/cuenta/favoritos'
      else if (this.section === 'sales') return '/cuenta/ventas'
      else if (this.section.startsWith('/perfil')) return this.section
    }
  },

  created () {
    window.addEventListener('resize', this.onResize)
    this.onResize()
  },


  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  },

  methods: {
    onResize () {
      this.windowWidth = Math.max(document.documentElement && document.documentElement.clientWidth || 0, window.innerWidth || 0);
    },

    createQuery (page) {
      return {
        ...this.$route.query,
        page
      }
    }
  }
}
</script>

<style lang="scss">
  @import '../../scss/breakpoints';

  .paginate {
    margin-left: auto;
    margin-right: auto;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
    width: min-content;
  }

  @media screen and (max-width: map-get($grid-breakpoints, "sm")) {
    .paginate {
      transform: scale(1.5);
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
    }

    .page-item {
      font-size: 1rem;

      &.change-page {
        text-align: center;
      }
    }

    .active {
      font-size: 1rem !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Paginate.vue